import { createFeatureSelector, createSelector } from "@ngrx/store";
import { StoreConstants } from "src/app/constants/StoreConstants";
import { GroupState } from "./group.state";
import { Group, GroupList } from "src/app/_models/Group";
import { HttpErrorResponse } from "@angular/common/http";

export const selectGroupState = createFeatureSelector<GroupState>(StoreConstants.STATE_GS);

export const selectAddGroupLoader = createSelector(
    selectGroupState,
    (state: GroupState): boolean => state.crudGroupLoader
);

export const selectAddGroupResult = createSelector(
    selectGroupState,
    (state: GroupState): Group | null => state.crudResult
);

export const selectAddGroupError = createSelector(
    selectGroupState,
    (state: GroupState): HttpErrorResponse => state.crudError
);

export const selectGroupListInitial = createSelector(
    selectGroupState,
    (state: GroupState): boolean => state.initialList
);

export const selectGroupList = createSelector(
    selectGroupState,
    (state: GroupState): GroupList[] => state.list
);

export const selectGroupListLength = createSelector(
    selectGroupState,
    (state: GroupState): number => state.listLength
);

export const selectGroupListLoader = createSelector(
    selectGroupState,
    (state: GroupState): boolean => state.listLoader
);

export const selectOrgCentreGroupList = createSelector(
    selectGroupState,
    (state: GroupState): Group[] => state.orgCentreGroupList  
);

export const selectOrgCentreGroupLoader = createSelector(
    selectGroupState,
    (state: GroupState): boolean => state.orgCentreGroupLoader
);

export const selectGroupNamesByIds = createSelector(
    selectGroupState,
    (state: GroupState, ids: number[]): string[] => state.orgCentreGroupList.filter(x => {
        let exist = false;
        ids.forEach(id => {
            if(id === x.id)
                exist = true;
        });
       return exist;
    }).map( x => x.name)
);

export const selectDeleteGroupLoader = createSelector(
    selectGroupState,
    (state: GroupState): boolean => state.deleteGroupLoader
);

export const selectIsDeleteGroup = createSelector( 
    selectGroupState,
    (state: GroupState): boolean => state.isDeleteGroup
);

export const selectDeleteGroupError = createSelector( 
    selectGroupState,
    (state: GroupState): HttpErrorResponse => state.deleteGroupError
);

export const selectCurrentPageNumber = createSelector(
    selectGroupState,
    (state: GroupState): number => state.currentPageNumber
);

export const selectLearnerIdsToAssignCourse = createSelector(
    selectGroupState,
    (state: GroupState): number[] => state.learnerIdsToAssignCourse
);